import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { enrolmentValidation } from "../Utils/PlanUtils";
import { Tooltip } from "react-tooltip";
import './EnrolmentValidationErrors.css';
import { useTranslation } from "react-i18next";

const EnrolmentValidationErrors = ({ state }) => {
    const [validationErrors, setValidationErrors] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();

    //Validate the enrolment data
    useEffect(() => {
        setValidationErrors(enrolmentValidation(state));
    }, [state]);

    const displayError = (error) => {
        if (error.autoNavigate && state.enrollment._id && error.autoNavigate.navigationControllerItemName) {
            let url = `/enrolment/${state.enrollment._id}/${error.autoNavigate.navigationControllerItemName}`;

            if (error.autoNavigate.inputItem) {
                url += `/${error.autoNavigate.inputItem}`;
            }

            return (
                <span className={'validation-error'}>
                    <Link to={url}>
                        <span>{error.message}</span>
                        <span className="material-symbols-outlined"
                            data-tooltip-content={t(`Jump to input field`)}
                            data-tooltip-id={'validation-tooltip'}
                            data-tooltip-place='top'
                        >
                            arrow_circle_right
                        </span>
                    </Link>
                </span>
            )
        } else {
            return <span className={'validation-error'}>{error.message}</span>
        }
    }

    if (validationErrors.length > 0) {
        if (expanded) {
            return (
                <div className={'validation-errors'}>
                    <span className="material-symbols-outlined validation-error-indicator"
                        data-tooltip-content={`${validationErrors.length} ${t("validation errors found")}`}
                        data-tooltip-id={'validation-tooltip'}
                        data-tooltip-place="bottom"
                    >
                        warning
                    </span>
                    <span className={'validation-error'}>{validationErrors.length} {t("validation errors found")}:</span>
                    <ul>
                        {validationErrors.map((error, index) => {
                            return (
                                <li key={index}>
                                    {displayError(error)}
                                </li>
                            )
                        })}
                    </ul>
                    <Tooltip id={'validation-tooltip'} className={'enrollment-progress-stepper-tooltip'} />
                </div>
            )
        } else {
            return (
                <div className={'validation-errors'}>
                    <span className="material-symbols-outlined validation-error-indicator"
                        data-tooltip-content={`${validationErrors.length} ${t("validation errors found")}`}
                        data-tooltip-id={'validation-tooltip'}
                        data-tooltip-place="bottom"
                    >
                        warning
                    </span>
                    <span className={'initial-validation-error'}>
                        {displayError(validationErrors[0])}
                    </span>
                    {validationErrors.length > 1 &&
                        <span className={'more-validation-errors-indicator'} onClick={() => { setExpanded(true); }}>{validationErrors.length - 1} {(validationErrors.length - 1) == 1 ? t('more validation error') : t('more validation errors')}...</span>
                    }
                    <Tooltip id={'validation-tooltip'} className={'enrollment-progress-stepper-tooltip'} />
                </div>
            )
        }

    } else {
        return null;
    }
}

export default EnrolmentValidationErrors;